import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

export const useIsTouchDevice = () => {
  const { deviceType, isMobile, isTablet } = useUserAgent();

  return (
    deviceType === 'mobile' ||
    deviceType === 'tablet' ||
    isMobile ||
    isTablet ||
    'ontouchstart' in document.documentElement
  );
};
